<template>
    <v-app>
        <v-container>
            <v-form lazy-validation v-model="FormTemplate" ref="FormTemplate">
                <div v-for="(Field, index) in Fields" :key="index">
                    <v-row align="center" justify="center">
                        <v-col v-for="(item, index) in Field.row" :key="index">
                            <v-text-field v-if="item.Type == 'text' || item.Type == 'Number'" :label="item.Label" v-model="item.DefaultVal" :type="item.Type" :required="item.FieldRequired" :rules="item.FieldRequired?[v => !!v || item.Label+'不能为空!']:[]"></v-text-field>

                            <v-select v-if="item.Type == 'select'" :label="item.Label" v-model="item.DefaultVal" :menu-props="{ top: true, offsetY: true }" :items="item.Items" item-text="key" item-value="value" persistent-hint return-object single-line :required="item.FieldRequired" :rules="item.FieldRequired?[v => !!v || item.Label+'不能为空!']:[]"></v-select>

                            <v-switch v-if="item.Type == 'switch'" :label="item.Label" v-model="item.DefaultVal" :rules="item.FieldRequired?[v => !!v || item.Label+'不能为空!']:[]"></v-switch>
                        </v-col>
                    </v-row>
                </div>
                <!-- <v-row>
                    <v-btn color="success" @click="submit">提交</v-btn>
                </v-row> -->
            </v-form>
        </v-container>
    </v-app>
</template>
<script>
    export default {  
  props: {
    Fields: {
      default: false,
      type: Array
    }
  },
  data() {
    return {
      FormTemplate:''
    }
  },
  methods: {
    validate() {
      //表单验证
      if (this.$refs.FormTemplate.validate()) {
       this.$emit('getFormData',this.Fields);
      }
    },
    // submit() {
    //   //表单验证通过，发送数据
    //   if (this.$refs.FormTemplate.validate()) {
    //    this.$emit('getFormData',this.Fields);
    //   }
    // },
    getData(){
      //发送数据
        return this.Fields
    },
    Rules(Field) {
      let RulesArray = [];

      if (Field.FieldRequired) {
        RulesArray.push(v => !!v || Field.Label + " is required");
      }

      if (Field.Counter > 0) {
        if (Field.DefaultVal) {
          RulesArray.push(
            v =>
              v.length <= Field.Counter ||
              "Max " + Field.Counter + " characters"
          );
        }
      }

      if (Field.Rules == "Email") {
        RulesArray.push(
          v =>
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
              v
            ) || "E-mail must be valid"
        );
      }

      if (Field.Rules == "Password") {
        if (Field.DefaultVal) {
          RulesArray.push(v => v.length >= 8 || "Min 8 characters");
        }
      }
      return RulesArray;
    }
  }
}
</script>
<style type="text/css" scoped>
>>>.v-application--wrap{
  min-height: 100%;
}
</style>